import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { UpperFirstLetterPipe } from '../../pipes/upper-first-letter-pipe';

@Component({
  selector: 'app-contact',
  imports: [TranslateModule, UpperFirstLetterPipe],
  templateUrl: './contact.html',
  styleUrl: './contact.scss',
})
export class Contact {}
